// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@awc/MobiusOverrides/TextField/TextField";
import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

customerAddressFormFieldStyles.container = {
    gap: 12,
    css: css`
        ${GridItemStyle} {
            padding-top: 6px;
            padding-bottom: 6px;
        }
    `,
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("Enter First Name"),
    type: "firstName",
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Enter Last Name"),
    type: "lastName",
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Enter Company Name"),
    type: "comapnyName",
} as TextFieldProps;

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Enter Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Enter Address"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Enter Address"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Enter Address"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Enter Address"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("Enter City"),
    type: "city",
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Enter ZIP"),
    type: "postalCode",
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("Enter Phone"),
    type: "phone",
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("Enter Fax"),
} as TextFieldProps;

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Enter Email"),
    type: "email",
} as TextFieldProps;

customerAddressFormFieldStyles.address1GridItem =
    customerAddressFormFieldStyles.addAddressLineLinkGridItem =
    customerAddressFormFieldStyles.address2GridItem =
    customerAddressFormFieldStyles.address3GridItem =
    customerAddressFormFieldStyles.address4GridItem =
    customerAddressFormFieldStyles.cityGridItem =
    customerAddressFormFieldStyles.countryGridItem =
    customerAddressFormFieldStyles.emailGridItem =
    {
        width: 6,
    };
